import { useParams } from "react-router-dom";
// import { useEffect } from 'react'
import { productsData } from "../components/ProductData";
import "../styles/ProductDetails.css"
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Canvas } from "@react-three/fiber"
import { OrbitControls, useGLTF } from "@react-three/drei";





// function Model({ imageicon }) {
//     const model = useGLTF(imageicon);
//     return <primitive object={model.scene} scale={[17, 17, 17]} />;
// }

function Model({ imageicon }) {
    const model = useGLTF(imageicon);

    return (
        <primitive
            object={model.scene}
            scale={[17, 17, 17]}
            
            rotation={[ 0, 0, -Math.PI / 2]} // 90° clockwise
        />
    );
}


export default function ProductDetails() {
    const { productId } = useParams();

    const product = productsData.find((p) => p.id === productId);

    if (!product) {
        return <h2 style={{ textAlign: "center", marginTop: "50px" }}>Product Not Found</h2>;
    }

    return (
        <div>
            <Navbar />
            <div className="details-container">
                {/* Header: Text Left, Image Right */}


                <div className="details-header">
                    <div className="details-info">
                        <h1 className="details-title">{product.name.split(/(?=[A-Z])/).map((word, index) => (
                            <span
                                key={index}
                                className={index === 0 ? "title-white" : "title-blue"}
                            >
                                {word}
                            </span>
                        ))}</h1>
                        {/* <p className="details-shortDesc">{product.shortDesc}</p> */}
                        <h3 className="details-longDesc">{product.longDesc}</h3>
                        <h4 className="demoBook">Book Demo</h4>
                    </div>
                    {/* <img src={product.image} alt={product.name} className="details-img" /> */}
                    {/* <div> */}

                    <Canvas className="details-img"
                        camera={{ fov: 50 }}
                        style={{ height: "400px" }}
                    >
                        <ambientLight intensity={1} />
                        <directionalLight position={[20, 20, 20]} />
                        <Model imageicon={product.image} />
                        <OrbitControls
                            target={[0, 0, 0]}
                            minDistance={2}
                            maxDistance={18}
                        />
                    </Canvas>
                    {/* </div> */}
                </div>

                {/* Features Section */}
                <div style={{ textAlign: "center" }}>
                    <button className="product-btn">Key Features</button>
                </div>
                {/* <div className="features-list">
                    {product.features.map((feature, index) => (
                        <div className="feature-item" key={index}>
                            <div className="feature-icon">{feature.icon}</div>
                            <div className="feature-text">
                                <h4>{feature.title}</h4>
                                <p>{feature.desc}</p>
                            </div>
                        </div>
                    ))}
                </div> */}
                <div className="feature-cards-container">
                    {product.features.map((feature, index) => (
                        <div className="card-container">
                            <div className="blurCircle">
                            </div>
                            <div className="feature-card-new" key={index}>
                                <div>
                                    <div className="feature-icon-bg">
                                        {/* <i className="feature-icon-new"></i> */}
                                        <i class={feature.icon}></i>
                                    </div>
                                    <div className="feature-text">
                                        <h4>{feature.title}</h4>
                                        <p>{feature.desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Detailed Description */}

                <div style={{ textAlign: "center" }}>
                    <button className="product-btn">Detailed Description</button>
                </div>



                <div class="glow-cards-container">
                    <div class="glow-card card-blue">
                        <h3>{product.detailDecs[0].que} ?</h3>
                        <p>{product.detailDecs[0].ans}</p>
                    </div>

                    <div class="glow-card card-yellow">
                        <h3>{product.detailDecs[1].que} ?</h3>
                        <p>{product.detailDecs[1].ans}</p>
                    </div>

                    <div class="glow-card card-pink">
                        <h3>{product.detailDecs[2].que} ?</h3>
                        <p>{product.detailDecs[2].ans}</p>
                    </div>
                </div>


                {/* Technical Specifications */}

                <div style={{ textAlign: "center", margin: "20px 0 40px 0" }}>
                    <button className="product-btn">Technical Specifications</button>
                </div>
                <table className="spec-table">
                    <thead>
                        <tr>
                            <th>Specifications</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {product.specs.map((spec, index) => (
                            <tr key={index}>
                                <td>{spec.label}</td>
                                <td>{spec.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
            <Footer />
        </div>
    );

};
